export const REACT_ADMIN_VALIDATION_REGEXP = /^@@react-admin@@["']|["']$/g;
export const DOMAIN_VALIDATION_REGEXP = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
